export default "__VITE_ASSET__CuUEpMrd__"